module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    style: (_vm.sidebarStyle)
  }, [_c('div', {
    staticClass: "row titlebar"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.sidebar.title))]), _vm._v(" "), (_vm.sidebar.titleAdditional) ? _c('span', {
    staticClass: "title-info"
  }, [_vm._v(_vm._s(_vm.sidebar.titleAdditional))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c(_vm.sidebar.view, {
    ref: "component",
    tag: "component",
    attrs: {
      "data": _vm.sidebar.outputData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row bottombar"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.sidebar.info) ? _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-alert', {
    staticClass: "info_",
    attrs: {
      "variant": _vm.sidebar.info.variant,
      "show": ""
    }
  }, [(_vm.sidebar.info.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.sidebar.info.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.sidebar.info.text))])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row controls"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-button', {
    class: ['apply-btn', {
      applying: _vm.applying
    }],
    attrs: {
      "variant": _vm.applyButton.variant
    },
    on: {
      "click": _vm.applyChanges
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.applyButton.text))]), _vm._v(" "), (_vm.applying) ? _c('stretch', {
    staticClass: "loader",
    attrs: {
      "background": "#fff",
      "size": "25px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.resetButton.visible && _vm.applyButton.applied) ? _c('b-button', {
    staticClass: "reset",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.triggerReset
    }
  }, [_c('span', [_vm._v("Zurücksetzen")])]) : _vm._e(), _vm._v(" "), (!_vm.applyButton.applied) ? _c('b-button', {
    staticClass: "cancel",
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v("\n\t\t\t\t\t\tAbbrechen\n\t\t\t\t\t")]) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e33d7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoSidebar.vue
// module id = 677
// module chunks = 0